import script from "./communityWillAuditApplyDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityWillAuditApplyDetail.vue?vue&type=script&lang=ts&setup=true"

import "./communityWillAuditApplyDetail.vue?vue&type=style&index=0&id=c4883122&lang=less"

const __exports__ = script;

export default __exports__